import { ERROR_AUTOCLOSE_TIMEOUT_MS } from 'Constants';
import React, { useState } from 'react';

import DeleteBorderButton from '../../Buttons/DeleteBorderButton';
import DeleteDialog from '../../Dialogs/DeleteDialog';

import authentication from 'Api/authentication';

import ErrorMessage from 'Components/UI/ErrorMessage';

import { isValidResponse } from 'Utils';

export default function DeleteUserBtn({
  displayOnly = false,
  afterDelete,
  userId,
  disabled,
  disabledReason,
  userName,
  sx,
}) {
  const buttonDisabledProps = disabled
    ? {
        disabled,
        tooltipText: !!disabled && disabledReason,
      }
    : {};

  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [mainError, setMainError] = useState('');

  const deleteUser = async () => {
    setDeleteInProgress(true);
    let isSuccess = false;
    try {
      const response = await authentication.removeOneUser(userId);
      isSuccess = isValidResponse(response);
      if (!isSuccess) {
        throw new Error(response?.data?.error?.message);
      }
    } catch (err) {
      console.log('Delete user error: ', err);
      setMainError(err?.message || `Couldn't delete user`);
      setTimeout(() => setMainError(''), ERROR_AUTOCLOSE_TIMEOUT_MS);
    } finally {
      setDeleteInProgress(false);
      setDialogOpen(false);
      if (isSuccess && typeof afterDelete === 'function') {
        afterDelete();
      }
    }
  };

  return displayOnly ? (
    <DeleteBorderButton sx={{ border: 0 }} variant="text" />
  ) : (
    <>
      <DeleteDialog
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        title="Delete user"
        itemName={userName || ''}
        isLoading={deleteInProgress}
        handleDelete={deleteUser}
      />
      {!!mainError && (
        <ErrorMessage
          message={mainError}
          handleCloseErrorAlert={() => setMainError(null)}
        />
      )}
      <DeleteBorderButton
        variant="text"
        clickAction={() => setDialogOpen(true)}
        sx={{ border: 0, ...sx }}
        {...buttonDisabledProps}
      />
    </>
  );
}
